export class MandatoryFor {
	criterionKey;
	values;

	constructor(criterionKey, values) {
		this.criterionKey = criterionKey;
		this.values = values;
	}
}
